import * as React from 'react';
import Hidden, { HiddenProps } from '../hidden/Hidden';

const Shown: React.FC<HiddenProps> = ({ when, ...restProps }) => {
  return <Hidden when={!when} {...restProps} />;
};

export default Shown;
